import { Base_Url } from "../../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../../ApiMethods/ApiMethod";

const ProjectStageUrl = `${Base_Url}/ProjectStage`;

export const GetProjectStageList = async (params) => {
  const res = await postApiWithAuthorization(
    `${ProjectStageUrl}/GetProjectStageList`,
    params
  );
  return res;
};

export const AddUpdateProjectStage = async (params) => {
  const res = await postApiWithAuthorization(
    `${ProjectStageUrl}/AddUpdateProjectStage?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};

export const GetProjectStageModel = async (ModuleName, KeyID, UserKeyID) => {
  const res = await getApiWithAuthorization(
    `${ProjectStageUrl}/GetProjectStageModel?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}&ProjectStageKeyID=${KeyID}`
  );
  return res;
};

export const ChangeProjectStageStatus = async (
  ModuleName,
  KeyID,
  UserKeyID
) => {
  const res = await getApiWithAuthorization(
    `${ProjectStageUrl}/ChangeProjectStageStatus?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}&ProjectStageKeyID=${KeyID}`
  );
  return res;
};

export const DeleteProjectStage = async (ModuleName, KeyID, UserKeyID) => {
  const res = await getApiWithAuthorization(
    `${ProjectStageUrl}/DeleteProjectStage?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}&ProjectStageKeyID=${KeyID}`
  );
  return res;
};

export const GetProjectStageLookupList = async (ModuleName, UserKeyID) => {
  const res = await getApiWithAuthorization(
    `${ProjectStageUrl}/GetProjectStageLookupList?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}`
  );
  return res;
};
